<template>
  <div class="page flex-col">
    <div class="top-bar flex-row">
      <img class="logo" referrerpolicy="no-referrer" src="./assets/img/SketchPng1b873447787c9cbb3e41368859a9d2c662c59bd8506395ceca20ebd4c958e4c0.png" />
      <span class="nav-link" @click="showContact = true">联系我们</span>
    </div>
    <div class="banner flex-col"><span class="banner-title">基于AI的建筑业数字化建造互联网平台</span></div>

    <div class="main-area flex-row">
      <div class="sidebar flex-col">
        <div class="nav-item" @click="$router.push('/lanhu_quanguochengshuzihua')">全过程数字化管控</div>
        <div class="nav-item" @click="$router.push('/lanhu_zhengxiangshejijieduan')">正向设计阶段</div>
        <div class="nav-item" @click="$router.push('/lanhu_heidengshengchanjieduan')">黑灯生产阶段</div>
        <div class="nav-item" @click="$router.push('/lanhu_wurenshigong')">无人/少人施工阶段</div>
        <div class="nav-item active" @click="$router.push('/lanhu_zhihuiyunwei')">智慧运维阶段</div>
        <div class="nav-item" @click="$router.push('/lanhu_qita')">其他AI智能体</div>
        <div class="nav-item" @click="showContact = true">定制开发模块</div>
      </div>

      <div class="content-area flex-row justify-between">
        <!-- BIM数字化管控和展示平台 -->
        <div class="card-box flex-col">
          <span class="card-title">BIM数字化管控和展示平台</span>
          <img class="card-icon" referrerpolicy="no-referrer" src="./assets/img/SketchPng828be697ba7194a9d21f1cd709ba658d643881e9f174cb6a30831fdf095e670c.png" />
          <span class="card-desc">
            本平台承接前期正向设计、施工、生产阶段的全部成果数据，将二维图纸、构件信息、施工记录、设备参数等内容挂载至三维&nbsp;BIM&nbsp;模型，打造&nbsp;"模型即数据、数据即管理"&nbsp;的一体化体系。是可视化展示窗口也是运维管控中枢。
          </span>
          <div class="download-btn contact-btn flex-col" @click="showContact=true"><span class="btn-text">联系我们</span></div>
        </div>
        <!-- AI大模型全屋智能管控模块 -->
        <div class="card-box flex-col">
          <span class="card-title">AI大模型全屋智能管控模块</span>
          <span class="card-sub">（定制）</span>
          <img class="card-icon" referrerpolicy="no-referrer" src="./assets/img/SketchPnge39dba2657d27f48a65b3e7a1486d2502236da13616ad3c58d2d5fc80a7f90a4.png" />
          <span class="card-desc">
            模块承接&nbsp;BIM&nbsp;数字化平台、物联网感知数据，以&nbsp;AI&nbsp;大模型为&nbsp;"智能大脑"，打破单设备独立控制、固定场景模式的局限。不再局限于简单开关、定时控制，而是结合环境数据、人员行为、使用习惯、运维规则做自主决策、动态优化。
          </span>
          <div class="download-btn contact-btn flex-col" @click="showContact=true"><span class="btn-text">联系我们</span></div>
        </div>
      </div>
    </div>

    <div class="footer flex-row">
      <img class="footer-logo" referrerpolicy="no-referrer" src="./assets/img/SketchPng23c7966a2d1963c6b88ae89421a6a417dd7b177ac534af52d26b60f665e3e49f.png" />
      <span class="footer-text">赢技科技发展（杭州）有限公司&nbsp;<br/>联系我们：yingji&#64;yjyunjz.com<br/>版权所有&nbsp;浙ICP备1214545号-1</span>
    </div>

    <div class="contact-modal-mask" v-if="showContact" @click.self="showContact = false">
      <div class="contact-modal">
        <div class="contact-modal-header"><span class="contact-modal-title">联系我们</span><span class="contact-modal-close" @click="showContact=false">✕</span></div>
        <div class="contact-modal-body">
          <div class="contact-item"><span class="contact-label">公司名称：</span><span class="contact-value">赢技科技发展（杭州）有限公司</span></div>
          <div class="contact-item"><span class="contact-label">联系邮箱：</span><a class="contact-value contact-link" href="mailto:yingji@yjyunjz.com">yingji@yjyunjz.com</a></div>
          <div class="contact-item"><span class="contact-label">官方网站：</span><span class="contact-value">www.yjyunjz.com</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { data() { return { showContact: false }; } };
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
.nav-link{cursor:pointer}.nav-link:hover{opacity:.75}
.download-btn{cursor:pointer;transition:opacity .2s,transform .15s}.contact-btn{background-color:rgba(0,145,255,1)}
.download-btn:hover{opacity:.85;transform:scale(1.03)}
.contact-modal-mask{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;z-index:9999}
.contact-modal{background:#fff;border-radius:12px;padding:32px 40px;min-width:380px;box-shadow:0 16px 48px rgba(0,0,0,.2)}
.contact-modal-header{display:flex;align-items:center;justify-content:space-between;margin-bottom:24px}
.contact-modal-title{font-size:20px;font-weight:700;color:#1a1a2e}
.contact-modal-close{cursor:pointer;font-size:18px;color:#999;padding:4px}.contact-modal-close:hover{color:#333}
.contact-modal-body{display:flex;flex-direction:column;gap:16px}
.contact-item{display:flex;align-items:flex-start;font-size:15px;line-height:1.6}
.contact-label{color:#666;white-space:nowrap;min-width:90px}
.contact-value{color:#1a1a2e;font-weight:500}
.contact-link{color:#2563eb;text-decoration:none}.contact-link:hover{text-decoration:underline}
</style>
